import { useLayoutEffect } from 'react';

/**
 * 依 Header 實際渲染高度，動態設定 --header-height CSS 變數。
 * 供 .main-container 的 padding-top 使用，讓內容永遠貼齊 fixed Header 下緣，
 * 不論 Header 是預設 logo 列或塞入較高的自訂內容（如 Stepper）。
 *
 * @param {React.RefObject<HTMLElement>} headerRef - 指向 <header> 元素的 ref
 */
export const useHeaderHeightVar = (headerRef) => {
    useLayoutEffect(() => {
        const el = headerRef.current;
        if (!el) return undefined;

        const root = document.documentElement;
        const applyHeight = () => root.style.setProperty('--header-height', `${el.offsetHeight}px`);

        applyHeight();

        // Header 內容切換（如塞入 Stepper）或視窗尺寸變動時同步更新
        const observer = new ResizeObserver(applyHeight);
        observer.observe(el);

        return () => {
            observer.disconnect();
            root.style.removeProperty('--header-height');
        };
    }, [headerRef]);
};
